/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const CompetenceList: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/competenceList/competenceList.component')
);
const SelfMarkSurvey: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/selfMarkSurvey/selfMarkSurvey.component')
);
const CompetenceDetails: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/competenceDetails/competenceDetails.component')
);

export const competenceRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.competences.children.competences, component: CompetenceList },
  { pathSettings: routingConfig.competences.children.competenceSelfMarkSurvey, component: SelfMarkSurvey },
  { pathSettings: routingConfig.competences.children.competenceEntry, component: CompetenceDetails },
];
